import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http.service';
import { Observable } from 'rxjs';
import { DashboardSummaryBlocksInterface } from '../interfaces/dashboard-summary-blocks.interface';
import { ProspectInterface } from '../interfaces/prospect.interface';

@Injectable({ providedIn: 'root' })
export class DashboardHttpService extends HttpService {
  getDashboardSummaryBlocksData(): Observable<DashboardSummaryBlocksInterface> {
    return this.http.get<DashboardSummaryBlocksInterface>(`${this.baseUrl}dashboard/summary-blocks`);
  }

  getProspect(): Observable<ProspectInterface> {
    return this.http.get<ProspectInterface>(`${this.baseUrl}prospect`);
  }
}
